import React, { useState } from 'react';
import './BlockStorageDemo.css';
import ebsIcon from './amazon-elastic-block-store-1.svg';

const BLOCKS = 12;

const awsOrange = '#FF9900';
// Fallback SVG for block storage if AWS CDN icon fails
const ebsIconFallback = 'https://raw.githubusercontent.com/aws/aws-icons-for-architecture/main/dist/Arch-Storage/Amazon-Elastic-Block-Store_EBS_48.svg';
const dbExamples = ['Postgres', 'MySQL'];

const BlockStorageDemo: React.FC = () => {
  const [activeBlock, setActiveBlock] = useState<number | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [animatingBlock, setAnimatingBlock] = useState<number | null>(null);

  const handleBlockClick = (i: number) => {
    setActiveBlock(i);
    setAnimatingBlock(i);
    const db = dbExamples[Math.floor(Math.random() * dbExamples.length)];
    setMessage(`${db} writes to block ${i + 1}!`);
    setTimeout(() => setAnimatingBlock(null), 350); // Animation duration
    setTimeout(() => setMessage(null), 1200); // Message fade out
  };

  return (
    <div className="block-demo-container wide">
      <div className="block-demo-header">
        <img src={ebsIcon} alt="AWS EBS Icon" className="aws-ebs-icon" />
        <h2 className="block-demo-title">EBS Block Storage</h2>
      </div>
      <div className="block-demo-desc">
        Block storage divides data into fixed-size blocks. Ideal for databases and VMs needing low-latency, high-performance storage. Each block can be read or written independently.
      </div>
      <div className="block-demo-message-area">
        {message && <div className="block-demo-message">{message}</div>}
      </div>
      <div className="block-grid">
        {[...Array(BLOCKS)].map((_, i) => (
          <div
            key={i}
            className={`block${activeBlock === i ? ' active' : ''}${animatingBlock === i ? ' animating' : ''}`}
            onClick={() => handleBlockClick(i)}
            title="Click to simulate read/write"
          >
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlockStorageDemo; 